import { allActiveMembersDataset } from '@/lib/member-views/datasets/allActiveMembers.dataset';
import type { ActiveMemberRow } from '@/lib/members/members.types';
import { MemberIdentityCell } from '../cells/MemberIdentityCell';
import { PhoneCell } from '../cells/PhoneCell';
import { PriorityTagsCell } from '../cells/PriorityTagsCell';
import { MemberViewShell, type MemberViewShellProps } from '../MemberViewShell';

const cellOverrides: MemberViewShellProps<ActiveMemberRow>['cellOverrides'] = {
  patient: (row) => <MemberIdentityCell firstName={row.firstName} lastName={row.lastName} mdvipId={row.mdvipId} />,
  phone: (row) => <PhoneCell mobile={row.mobilePhone} home={row.phone} />,
  priorityTags: (row) => <PriorityTagsCell tags={row.priorityTags} />,
};

/**
 * All Active Members, the directory's default view.
 *
 * A function declaration on purpose: the view registry imports this component, and the shell it
 * renders imports the registry back (through the view select). A hoisted function is defined
 * whichever side of that cycle loads first; a `const` component could be read before it's assigned.
 */
export function AllActiveMembersView() {
  return <MemberViewShell dataset={allActiveMembersDataset} cellOverrides={cellOverrides} />;
}
